import { createFileRoute, Navigate } from '@tanstack/react-router';

import { NotificationSettingsOverview } from '@apps/web/components/settings/notification_settings_overview';
import { SettingsPageShell } from '@apps/web/features/settings';

export const Route = createFileRoute('/_app/settings/notifications/')({
    component: NotificationsHubPage,
});

function NotificationsHubPage() {
    const search = Route.useSearch();
    if (search.unsubscribeEmailType) {
        return (
            <Navigate
                to="/settings/notifications/$channel"
                params={{ channel: 'email' }}
                search={search}
                replace={true}
            />
        );
    }
    return (
        <SettingsPageShell title="Notifications">
            <NotificationSettingsOverview highlight={search.highlight} />
        </SettingsPageShell>
    );
}
